import API_CONFIG from '../config/api';

export interface Command {
  _id: string;
  type: 'instruction' | 'reason' | 'problem';
  text: string;
  order: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CommandsResponse {
  instructions: Command[];
  reasons: Command[];
  problems: Command[];
}

export interface CreateCommandRequest {
  type: 'instruction' | 'reason' | 'problem';
  text: string;
}

export interface UpdateCommandRequest {
  text: string;
}

class CommandService {
  private getAuthHeaders() {
    const token = localStorage.getItem('authToken');
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };
  }

  async getCommands(): Promise<CommandsResponse> {
    try {
      const response = await fetch(`${API_CONFIG.baseURL}/admin/commands`, {
        method: 'GET',
        headers: this.getAuthHeaders()
      });

      if (!response.ok) {
        throw new Error('Failed to fetch commands');
      }

      const data = await response.json();
      return data;
    } catch (error) {

      throw error;
    }
  }

  async createCommand(commandData: CreateCommandRequest): Promise<Command> {
    try {
      const response = await fetch(`${API_CONFIG.baseURL}/admin/commands`, {
        method: 'POST',
        headers: this.getAuthHeaders(),
        body: JSON.stringify(commandData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to create command');
      }

      const data = await response.json();
      return data;
    } catch (error) {

      throw error;
    }
  }

  async updateCommand(id: string, commandData: UpdateCommandRequest): Promise<Command> {
    try {
      const response = await fetch(`${API_CONFIG.baseURL}/admin/commands/${id}`, {
        method: 'PUT',
        headers: this.getAuthHeaders(),
        body: JSON.stringify(commandData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to update command');
      }

      const data = await response.json();
      return data;
    } catch (error) {

      throw error;
    }
  }

  async deleteCommand(id: string): Promise<void> {
    try {
      const response = await fetch(`${API_CONFIG.baseURL}/admin/commands/${id}`, {
        method: 'DELETE',
        headers: this.getAuthHeaders()
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to delete command');
      }
    } catch (error) {

      throw error;
    }
  }
}

export default new CommandService(); 